/** Entity officer / controller / shareholder row — IS_DEL=0 만 활성 (Entity 화면과 동일 규칙). */
export function isActiveEntityRow(row: Record<string, unknown> | null | undefined): boolean {
  if (!row || typeof row !== 'object') return false;
  const raw = (row as { isDel?: unknown; IS_DEL?: unknown }).isDel
    ?? (row as { IS_DEL?: unknown }).IS_DEL;
  if (raw === undefined || raw === null || raw === '') return true;
  return raw === 0 || raw === '0' || raw === false;
}

export function filterActiveEntityRows<T extends Record<string, unknown>>(rows: T[]): T[] {
  return rows.filter((r) => isActiveEntityRow(r));
}
